import Link from "next/link";
import AcceptForm from "../AcceptForm";
import CustomerInfo from "../CustomerInfoForm";
import * as Styled from "./CompleteTransfer.styled";
import { FormContainer, LegalText, TransferFooter } from "./CompleteTransfer.styled";
import { TransferState, useCompleteTransfer } from "./useCompleteTransfer";

const CompleteTransfer = () => {
  const {
    status,
    acceptTransfer,
    completeTransfer,
    transfererEmail,
    created,
    intentToken,
    apiError,
    setApiError,
  } = useCompleteTransfer();

  let Form: JSX.Element;
  switch (status) {
    case TransferState.PENDING: {
      Form = (
        <AcceptForm
          transferCreated={created}
          transferFrom={transfererEmail}
          onSubmit={acceptTransfer}
        />
      );
      break;
    }
    case TransferState.ACCEPTED: {
      Form = (
        <CustomerInfo
          intentToken={intentToken}
          handleSubmit={completeTransfer}
          handleError={setApiError}
        />
      );
      break;
    }
    default: {
      Form = <></>;
    }
  }
  return (
    <FormContainer>
      {Form}
      {apiError && <Styled.ErrorMessage>{apiError}</Styled.ErrorMessage>}
      <TransferFooter>
        <LegalText>
          By completing an account transfer, you agree to our{" "}
          <Link href="/terms">terms and conditions</Link> and{" "}
          <Link href="/privacy-policy/">privacy policy</Link>
        </LegalText>
      </TransferFooter>
    </FormContainer>
  );
};

export default CompleteTransfer;
